import { inkIconTokens } from '@ds/tokens'

const breadcrumb = {
  separatorColor: inkIconTokens.iconColorDefault,
} as const

export default breadcrumb
